import { Container, Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logoBlanco from "../../assets/images/logo_blanco.png";

const Header = () => {
  return (
    <header>
      <Navbar bg="primary" variant="dark" expand="md" collapseOnSelect>
        <Container>
          {/* Marca que navega a “/” */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Navbar.Brand as={Link} to="/" style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={logoBlanco}
                alt="Logo"
                style={{ height: '30px', marginRight: '0.5rem', display: 'block' }}
              />
              Manus fortis
            </Navbar.Brand>
          </div>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/">
                Inicio
              </Nav.Link>

              <Nav.Link as={Link} to="/cita">
                Pide cita
              </Nav.Link>

              <Nav.Link as={Link} to="/masajes">
                Nuestros masajes
              </Nav.Link>

              <Nav.Link as={Link} to="/contacto">
                Contacto
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
